// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  loadingHide,
  loadingShow,
} from 'redux/modules/loading'

// displays a global loading icon,
// runs the thunk()
// then hides the loading icon

const loadingToggler = thunk => async dispatch => {
  await dispatch(loadingShow())
  try {
    const res = await thunk()
    await dispatch(loadingHide())
    return res
  } catch (err) {
    // if the thunk throws an error,
    // be sure to close the loading icon before throwing the error to the caller
    await dispatch(loadingHide())
    throw err
  }
}

export default loadingToggler
